import React from 'react';
import { bool } from 'prop-types';
import Shimmer from '@airasia/phoenix-components/components/Shimmer';
import styled, { keyframes } from 'styled-components';
import Column from '../Container/Column';
import Row from '../Container/Row';
import Wrapper from '../Wrapper';
import ShimmerHotelCard from './ShimmerHotelCard';

const keyFrameExampleOne = keyframes`
   0%{
        background-position: -668px 0
    }
    100%{
        background-position: 668px 0
    }
`;

const ShimmerComponent = styled.div`
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${keyFrameExampleOne};
  animation-timing-function: linear;
  background: #f6f7f8;
  border: 0;
  border: 0px;
  background: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-size: 100% 100%;
  position: relative;
`;
const TopHeader = styled(Wrapper)`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  display: flex;
`;
const ShadowBox = styled(Wrapper)`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
const ShadowBoxHotels = styled(Wrapper)`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
`;
const MainBody = styled(Wrapper)`
  width: calc(100% - 32px);
  max-width: 1224px;
  margin: 0px auto;
  padding: 0px 16px;
`;
const MAP_IMAGE_URL =
  'https://static.airasia.com/snap/images/Map_View_Button_Image_MOVE.png';

const WebShimmer = () => (
  <>
    <ShimmerComponent>
      <TopHeader>
        <Row mt={10} mb={10} alignItems="center">
          <Wrapper ml={100}>
            <Shimmer borderRadius="2px" width="200px" height="50px" />
          </Wrapper>
          <Wrapper alignItems="flex-end" ml={700}>
            <Shimmer borderRadius="2px" width="200px" height="50px" />
          </Wrapper>
          <Wrapper alignItems="flex-end" ml={40}>
            <Shimmer borderRadius="2px" width="200px" height="50px" />
          </Wrapper>
        </Row>
      </TopHeader>
    </ShimmerComponent>
    <MainBody>
      <ShimmerComponent>
        <Row mt={40} mb={10} alignItems="center">
          <Wrapper ml={10} mr={10}>
            <Shimmer borderRadius="2px" width="340px" height="58px" />
          </Wrapper>
          <Wrapper ml={10} mr={10}>
            <Shimmer borderRadius="2px" width="340px" height="58px" />
          </Wrapper>
          <Wrapper ml={10} mr={10}>
            <Shimmer borderRadius="2px" width="231px" height="58px" />
          </Wrapper>
          <Wrapper ml={10}>
            <Shimmer borderRadius="2px" width="170px" height="58px" />
          </Wrapper>
        </Row>
      </ShimmerComponent>
      <Row mt={40} mb={10} alignItems="center">
        <Wrapper ml={10} mr={10}>
          <img src={MAP_IMAGE_URL} alt="MAP" width="300" height="158"></img>
        </Wrapper>
        <ShadowBoxHotels>
          <ShimmerComponent>
            <Column ml={10} mt={20} mb={20}>
              <Wrapper ml={10} onLoadedMetadata={10}>
                <Shimmer borderRadius="2px" width="240px" height="14px" />
              </Wrapper>
              <Wrapper ml={10} mt={10}>
                <Shimmer borderRadius="2px" width="340px" height="24px" />
              </Wrapper>
              <Wrapper ml={10} mt={10} mr={10}>
                <Shimmer borderRadius="4px" width="700px" height="42px" />
              </Wrapper>
            </Column>
          </ShimmerComponent>
        </ShadowBoxHotels>
      </Row>
      <Row mt={20}>
        <Column mr={10}>
          <SortAndFilter />
          <Wrapper mt={15}>
            <Shimmer mt={2} borderRadius="2px" width="320px" height="2px" />
          </Wrapper>
          <SortAndFilter />
          <Wrapper mt={15}>
            <Shimmer mt={2} borderRadius="2px" width="320px" height="2px" />
          </Wrapper>
          <SortAndFilter />
          <Wrapper mt={15}>
            <Shimmer mt={2} borderRadius="2px" width="320px" height="2px" />
          </Wrapper>
          <SortAndFilter />
          <Wrapper ml={10} mt={15}>
            <Shimmer mt={2} borderRadius="2px" width="320px" height="2px" />
          </Wrapper>
          <SortAndFilter />
          <Wrapper mt={15}>
            <Shimmer mt={2} borderRadius="2px" width="320px" height="2px" />
          </Wrapper>
        </Column>
        <Column ml={30}>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
          <Wrapper mb={15}>
            <ShimmerComponent>
              <ShimmerHotelCard />
            </ShimmerComponent>
          </Wrapper>
        </Column>
      </Row>
    </MainBody>
  </>
);
const MwebShimmer = () => (
  <ShimmerComponent>
    <Column ml={30}>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
      <Wrapper mb={15}>
        <ShimmerComponent>
          <ShimmerHotelCard />
        </ShimmerComponent>
      </Wrapper>
    </Column>
  </ShimmerComponent>
);

const SortAndFilter = () => (
  <ShadowBox>
    <ShimmerComponent>
      <Wrapper ml={10} mt={20} mr={10}>
        <Shimmer borderRadius="4px" width="150px" height="20px" />
      </Wrapper>
      <Wrapper ml={10} mt={20} mr={10}>
        <Shimmer borderRadius="4px" width="280px" height="15px" />
      </Wrapper>
      <Wrapper ml={10} mt={20}>
        <Shimmer borderRadius="4px" width="280px" height="15px" />
      </Wrapper>
      <Wrapper ml={10} mt={20}>
        <Shimmer borderRadius="4px" width="280px" height="15px" />
      </Wrapper>
      <Wrapper ml={10} mt={20} mb={30}>
        <Shimmer borderRadius="4px" width="280px" height="15px" />
      </Wrapper>
    </ShimmerComponent>
  </ShadowBox>
);

const ShimmerHotelListingPage = ({ isMobileView }) => {
  return isMobileView ? <MwebShimmer /> : <WebShimmer />;
};

ShimmerHotelListingPage.propTypes = {
  isMobileView: bool,
};

export default ShimmerHotelListingPage;
